import { GameState } from "@lib/titan2-slingo/dist/api/model/enum/GameState";
import { Service } from "@lib/titan2-slingo/dist/api/Service";
import { SlingoEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
import { ArcadeWheelEvent } from "@lib/titan2-slingo/dist/game/view/abstract/display/ArcadeWheel";
import { ControlPanel } from "@lib/titan2-slingo/dist/game/view/abstract/display/ControlPanel";
import { TitanButton } from "@lib/titan2/dist/game/control/TitanButton";
import { CommonGameEvent } from "@lib/titan2/dist/game/controller/event/CommonGameEvent";
import { ResizeEvent } from "@lib/titan2/dist/game/renderer/Renderer";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { GameEvent } from "../../../controller/event/GameEvent";
/**
 * GameControlPanel.ts
 */
export class GameControlPanel extends ControlPanel {
    handleMouseBlockerSelected() {
        this.model.dispatchKPI("SLNGO_STATE", "MINI_PAY_TABLE_CLOSED", null);
        this.closeAllWithEvent();
    }
    closeAllWithEvent() {
        this.hideMouseBlocker();
        if (this.payTable) {
            this.handlePayTableClose();
            this.dispatchGame(SlingoEvent.PAY_TABLE_CLOSE);
        }
    }
    closeAll() {
        this.hideMouseBlocker();
        if (this.payTable) {
            this.handlePayTableClose();
        }
    }
    create() {
        super.create();
        // The spins remaining must be within the control panel because the stake selector menu is part of the control panel.
        const spinsRemaining = this.factory.createSpinsRemaining();
        this.addChildAt(spinsRemaining, 0);
    }
    postCreate() {
        this.hideMouseBlocker();
        Logger.addObjectRef(this, "ControlPanel");
        this.hideCollect();
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(GameEvent.FORCE_COLLECT, this.showCollect);
        this.registerGame(SlingoEvent.GAME_SUMMARY, this.handleGameSummary);
        this.registerGame(ResizeEvent.REINITIALISE_TEXT, this.handleReinitialiseText);
        this.registerGame(ArcadeWheelEvent.STAKE_TO_SPIN_RESULT, this.hideCollect);
        this.registerGame(GameEvent.NEXT_GAME_TRANSITION, this.handleNextGameTransition);
    }
    handleStandardSpin() {
        super.handleStandardSpin();
        TitanButton.showButton(this.spinButton);
        if (Service.isReplay()) {
            TitanButton.disableButton(this.spinButton);
        }
    }
    handlePurchaseSpin() {
        super.handlePurchaseSpin();
        if (!this.model.isStakeToSpin() && !this.model.isChooseCell()) {
            TitanButton.showButton(this.purchaseSpinButton);
        }
        if (Service.isReplay()) {
            TitanButton.disableButton(this.purchaseSpinButton);
        }
    }
    handlePayTableOpen() {
        super.handlePayTableOpen();
        this.payTable.updateTransform();
    }
    handlePayTableClose() {
        this.payTable.hide();
    }
    handleSendCollectRequest() {
        //Stop button selected state from changing
        this.model.dispatchKPI("SLINGO_STATE", "COLLECT_BUTTON_PRESSED", null);
        this.dispatchGame(CommonGameEvent.COLLECT_REQUEST);
        this.disableButton(this.collectButton);
        this.disableButton(this.purchaseSpinButton);
    }
    showCollect() {
        if (this.model.isSpin()) {
            const totalWin = this.model.getTotalWin();
            if (totalWin > 0) {
                this.collectButtonValueText.setText(this.formatCurrency(this.model.getTotalWin()), true);
                TitanButton.showButton(this.collectButton);
            }
            else {
                TitanButton.showButton(this.endGameButton);
            }
        }
    }
    handleGameSummary() {
        TitanButton.hideButton(this.purchaseSpinButton);
        this.optionsMenuButton.disable();
        this.spinButton.show();
    }
    handleStartGameButtonSelected() {
        super.handleStartGameButtonSelected();
        this.model.setAutoSpin(true);
    }
    handleFreeSpinRecovery() {
        super.handleFreeSpinRecovery();
        // GRSOP-111 - The start game button should not be shown in free spins, but the core control panel shows it simultaneously with the free spin button.
        TitanButton.hideButton(this.startGameButton);
    }
    resetButtons() {
        if (this.model.getState() === GameState.CHOOSE_CELL) {
            this.purchaseSpinButton.getTextField().hide();
        }
        else {
            this.purchaseSpinButton.getTextField().show();
        }
        for (const button of this.buttons) {
            TitanButton.hideButton(button);
        }
        this.spinPrice.setText(this.spinPrice.getText(), true);
    }
    updateSpinPrice(amount) {
        if (amount > 0 && !this.model.isStakeToSpin()) {
            const formattedAmount = this.formatCurrency(amount);
            this.spinPrice.setText(formattedAmount, true);
            this.spinPrice.alpha = 1;
            this.replaySpinPrice.setText(formattedAmount, true);
            this.replaySpinPrice.alpha = 1;
            this.purchaseSpinButton.getTextField().show();
            this.purchaseSpinButton.getTextField().updateBounds();
        }
        else {
            this.spinPrice.setText("");
            this.replaySpinPrice.setText("");
            this.purchaseSpinButton.getTextField().hide();
        }
    }
    handleReinitialiseText() {
        this.purchaseSpinButton.updateAlign();
    }
    handleNextGameTransition() {
        this.optionsMenuButton.disable();
    }
}
//# sourceMappingURL=GameControlPanel.js.map